import {Form, Input, Modal} from "antd";
import React, {useState} from "react";
import * as yup from "yup";
import {useStore} from "../../../../../hooks/useStore";
import {useFormik} from "formik";

export const CreditLimitUpdateModal = ({visibilityState, onCancel, subcompanyId}) => {
    const stores = useStore();
    const [creditAlertLimit, setCreditAlertLimit] = useState();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [visibility, setVisibility] = visibilityState;

    const initialValues = {
        subCompanyId: subcompanyId,
        creditAlertLimit
    };

    const [validationSchema, setValidationSchema] = useState(
        yup.object().shape({
            creditAlertLimit: yup.number().min(0, "Kredi uyarı limiti 0'dan büyük olmalıdır")
        })
    );

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                const {creditAlertLimit} = values;

                await stores.companyStore.updateCreditAlertLimit({
                    subCompanyId: subcompanyId,
                    creditAlertLimit: parseInt(creditAlertLimit)
                });

                onCancel(true);
            } catch (error) {
                console.error(error);
            } finally {
                setConfirmLoading(false);
                setVisibility(false);
            }
        }
    });

    const {handleSubmit, errors, touched} = formik;

    return (
        <Modal
            title="Kredi Uyarı Limiti Güncelle"
            visible={visibility}
            onCancel={() => {
                onCancel(false);
                setVisibility(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText="Kaydet"
            cancelText="İptal"
        >
            <Form>
                <Form.Item
                    validateStatus={
                        errors.creditAlertLimit && touched.creditAlertLimit ? "error" : "success"
                    }
                    help={
                        errors.creditAlertLimit && touched.creditAlertLimit
                            ? errors.creditAlertLimit
                            : null
                    }
                >
                    <Input
                        type="number"
                        name="creditAlertLimit"
                        onChange={e => setCreditAlertLimit(e.target.value)}
                        value={creditAlertLimit}
                        data-testid="creditAlertLimitInput"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
